import {
  IQOSAddLeadAPIRequest,
  IQOSFetchLeadsAPIRequest,
  IQOSFetchVenueLeadsAPIRequest,
  IQOSSearchStaffAPIRequest,
  IQOSUpdateLeadAPIRequest,
} from 'utils/constants/network';
import { callAPI } from 'utils/network';

export const REQUEST_ADD_LEAD = 'REQUEST_ADD_LEAD';
export const DID_ADD_LEAD = 'DID_ADD_LEAD';
export const REQUEST_UPDATE_LEAD = 'REQUEST_UPDATE_LEAD';
export const DID_UPDATE_LEAD = 'DID_UPDATE_LEAD';
export const REQUEST_VENUE_LEADS = 'REQUEST_VENUE_LEADS';
export const DID_FETCH_VENUE_LEADS = 'DID_FETCH_VENUE_LEADS';
export const REQUEST_PENDING_LEADS = 'REQUEST_PENDING_LEADS';
export const REQUEST_ARCHIVED_LEADS = 'REQUEST_ARCHIVED_LEADS';
export const REQUEST_SUCCESSFUL_LEADS = 'REQUEST_SUCCESSFUL_LEADS';
export const DID_FETCH_SUCCESSFUL_LEADS = 'DID_FETCH_SUCCESSFUL_LEADS';
export const DID_FETCH_PENDING_LEADS = 'DID_FETCH_PENDING_LEADS';
export const DID_FETCH_ARCHIVED_LEADS = 'DID_FETCH_ARCHIVED_LEADS';
export const QUEUE_DRAFT_LEAD = 'QUEUE_DRAFT_LEAD';
export const PROCESS_QUEUED_LEADS = 'PROCESS_QUEUED_LEADS';
export const REMOVE_DRAFT_LEAD = 'REMOVE_DRAFT_LEAD';
export const CLEAR_IQOS_FLAGS = 'CLEAR_IQOS_FLAGS';
export const SEARCH_IQOS_STAFF = 'CLEAR_IQOS_STAFF';
export const DID_SEARCH_STAFF = 'DID_SEARCH_STAFF';
export const UPDATE_LEAD_FILTERS = 'UPDATE_LEAD_FILTERS';
export const UPDATE_FETCH_GLOBAL = 'UPDATE_FETCH_GLOBAL';

export const clearIQOSFlags = () => {
  return {
    type: CLEAR_IQOS_FLAGS,
    payload: {
      addingLead: false,
      updatingLead: false,
      fetchingVenueLeads: false,
      fetchingArchivedLeads: false,
      fetchingPendingLeads: false,
      fetchingSuccessfulLeads: false,
      searchingStaff: false,
    },
  };
};

export const queueLead = lead => ({
  type: QUEUE_DRAFT_LEAD,
  payload: {
    leadToQueue: lead,
  },
});

export const removeQueuedLead = lead => ({
  type: REMOVE_DRAFT_LEAD,
  payload: {
    leadToDequeue: lead,
  },
});

export const processQueuedLeads = () => ({
  type: PROCESS_QUEUED_LEADS,
  payload: {},
});

const requestAddLead = () => ({
  type: REQUEST_ADD_LEAD,
  payload: {
    addingLead: true,
    leadAdded: false,
    leadAddedError: null,
  },
});

const didAddLead = (success, err = null) => ({
  type: DID_ADD_LEAD,
  payload: {
    addingLead: false,
    leadAdded: success,
    leadAddedError: err,
  },
});

const requestUpdateLead = () => ({
  type: REQUEST_UPDATE_LEAD,
  payload: {
    updatingLead: true,
    leadUpdated: false,
    leadUpdatedError: null,
  },
});

const didUpdateLead = (success, err = null) => ({
  type: DID_UPDATE_LEAD,
  payload: {
    updatingLead: false,
    leadUpdated: success,
    leadUpdatedError: err,
  },
});

const requestVenueLeads = () => ({
  type: REQUEST_VENUE_LEADS,
  payload: {
    fetchingVenueLeads: true,
    venueLeadsFetched: false,
    venueLeads: null,
    venueLeadsError: null,
  },
});

const didFetchVenueLeads = (data, success, err) => ({
  type: DID_FETCH_VENUE_LEADS,
  payload: {
    fetchingVenueLeads: false,
    venueLeadsFetched: success,
    venueLeads: data,
    venueLeadsError: err,
  },
});

const requestPendingLeads = () => ({
  type: REQUEST_PENDING_LEADS,
  payload: {
    fetchingPendingLeads: true,
    pendingLeadsFetched: false,
    pendingLeadsFetchError: null,
  },
});

const requestSuccessfulLeads = () => ({
  type: REQUEST_SUCCESSFUL_LEADS,
  payload: {
    fetchingSuccessfulLeads: true,
    successfulLeadsFetched: false,
    successfulLeadsFetchError: null,
  },
});

const requestArchivedLeads = () => ({
  type: REQUEST_ARCHIVED_LEADS,
  payload: {
    fetchingArchivedLeads: true,
    archivedLeadsFetched: false,
    archivedLeadsFetchError: null,
  },
});

const didFetchSuccessfulLeads = (data, success, error) => ({
  type: DID_FETCH_SUCCESSFUL_LEADS,
  payload: {
    fetchingSuccessfulLeads: false,
    successfulLeadsFetched: success,
    successfulLeads: data.leads || [],
    successfulLeadsPageCount: data.total_pages + 1,
  },
});

const didFetchPendingLeads = (data, success, error) => ({
  type: DID_FETCH_PENDING_LEADS,
  payload: {
    fetchingPendingLeads: false,
    pendingLeadsFetched: success,
    pendingLeads: data.leads || [],
    pendingLeadsPageCount: data.total_pages + 1,
  },
});

const didFetchArchivedLeads = (data, success, error) => ({
  type: DID_FETCH_ARCHIVED_LEADS,
  payload: {
    fetchingArchivedLeads: false,
    archivedLeadsFetched: success,
    archivedLeads: data.leads || [],
    archivedLeadsPageCount: data.total_pages + 1,
  },
});

const requestStaffSearch = () => ({
  type: SEARCH_IQOS_STAFF,
  payload: {
    searchingStaff: true,
    staffSearched: false,
    iqosStaff: [],
    staffSearchError: null,
  },
});

const didSearchStaff = (data, success, error) => ({
  type: DID_SEARCH_STAFF,
  payload: {
    searchingStaff: false,
    staffSearched: success,
    iqosStaff: data.users || [],
    staffSearchError: error,
  },
});

export const updateLeadFilters = changes => ({
  type: UPDATE_LEAD_FILTERS,
  payload: {
    leadFilterChanges: changes,
  },
});

export const updateFetchGlobalFlag = checked => ({
  type: UPDATE_FETCH_GLOBAL,
  payload: {
    fetchGlobal: checked,
  },
});

export const fetchVenueLeads = () => {
  return dispatch => {
    dispatch(requestVenueLeads());

    const apiRequest = IQOSFetchVenueLeadsAPIRequest({});

    return callAPI(apiRequest)
      .then(json => dispatch(didFetchVenueLeads(json, true)))
      .catch(err => {
        dispatch(didFetchVenueLeads(null, false, err));
      });
  };
};

export const searchStaff = query => {
  return dispatch => {
    dispatch(requestStaffSearch());

    const apiRequest = new IQOSSearchStaffAPIRequest({ query: query });

    return callAPI(apiRequest, false, true)
      .then(json => {
        dispatch(didSearchStaff(json || [], true, null));
      })
      .catch(err => {
        dispatch(didSearchStaff([], false, err));
      });
  };
};

export const fetchLeads = (status, page, filters, global, from, to) => {
  return dispatch => {
    if (status === 'pending') {
      dispatch(requestPendingLeads());
    }
    if (status === 'successful') {
      dispatch(requestSuccessfulLeads());
    }
    if (status === 'archived') {
      dispatch(requestArchivedLeads());
    }

    const apiRequest = IQOSFetchLeadsAPIRequest({
      status: status,
      page: page,
      limit: 25,
      filter: filters,
      global: global,
      from: from,
      to: to,
    });

    return callAPI(apiRequest)
      .then(json => {
        if (status === 'pending') {
          dispatch(didFetchPendingLeads(json || {}, true, null));
        }
        if (status === 'successful') {
          dispatch(didFetchSuccessfulLeads(json || {}, true, null));
        }
        if (status === 'archived') {
          dispatch(didFetchArchivedLeads(json || {}, true, null));
        }
      })
      .catch(err => {
        if (status === 'pending') {
          dispatch(didFetchPendingLeads({}, false, err));
        }
        if (status === 'successful') {
          dispatch(didFetchSuccessfulLeads({}, false, err));
        }
        if (status === 'archived') {
          dispatch(didFetchArchivedLeads({}, false, err));
        }
      });
  };
};

export const updateLead = newLead => {
  return dispatch => {
    dispatch(requestUpdateLead());

    const apiRequest = IQOSUpdateLeadAPIRequest({
      lead: newLead,
    });

    return callAPI(apiRequest)
      .then(json => dispatch(didUpdateLead(true)))
      .catch(err => {
        dispatch(didUpdateLead(false, err.message));
      });
  };
};

export const addLead = lead => {
  return dispatch => {
    dispatch(requestAddLead());

    const apiRequest = IQOSAddLeadAPIRequest({
      lead: lead,
    });

    return callAPI(apiRequest, false, true)
      .then(json => dispatch(didAddLead(true)))
      .catch(err => {
        console.log(`Lead Creation Error: ${err.message}`);

        if (err.message === 'timeout') {
          // the internet connection is messy, save the booking as a draft
          lead.draft = true;
          lead.draft_timestamp = new Date().getTime();

          dispatch(queueLead(lead));
        }

        dispatch(didAddLead(false, err.message));
      });
  };
};



// WEBPACK FOOTER //
// ./src/actions/iqos/index.js